import { AssetInfo } from './../../../models/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { ApiService } from 'src/app/providers/api.service';
import { Component, Inject, OnInit, OnDestroy, NgZone } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BuisnessPromotion } from 'src/app/models/common';
import { TOUCH_BUFFER_MS } from '@angular/cdk/a11y';

@Component({
  selector: 'sm-add-admin-post',
  templateUrl: './add-admin-post.component.html',
  styleUrls: ['./add-admin-post.component.scss'],
})
export class AddAdminPostComponent implements OnInit, OnDestroy {
  public buisnessPromotionData: BuisnessPromotion = new BuisnessPromotion();
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  public loader: boolean = false;
  private _assetInfo: AssetInfo[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private _ngZone: NgZone
  ) {}

  removeAsset(index: any) {
    console.log(index);
    this.assetList.splice(index, 1);
  }

  ngOnInit(): void {
    let data: any = new BuisnessPromotion();

    Object.assign(data, this.parentData.data);
    console.log(data);
    if (data.hash_id) {
      JSON.parse(data.assetInfo).map((v: any, i: any) => {
        console.log(v.imgUrl.split('/'));
        this.assetList.push({
          assetName: v.imgUrl
            .split('/')
            .pop()
            .substring(v.imgUrl.split('/').pop().lastIndexOf('_') + 1),
          url: v.imgUrl,
          thumbnail: v.imageThumbUrl,
        });
      });
      this.buisnessPromotionData = data;
      this.editMode = true;
    }
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result.url);
        this._ngZone.run(() => {
          this.assetList.push({
            assetName: this.fileName,
            url: res.result?.url,
            thumbnail: res.result?.thumbnail,
          });
          console.log(this.assetList);
          this.loader = false;
        });
        // this.buisnessPromotionData.imgUrl = res.result?.url;
      }
      if (res.responseType === SM_CONSTANTS.UPDATE_ADMIN_POST_INFO_RESULT) {
        if (data) {
          this._snackBar.open('Admin post updated successfully', 'Ok', {
            duration: 3000,
          });
        } else {
          this._snackBar.open('Admin post added successfully', 'Ok', {
            duration: 3000,
          });
        }
        this.parentData.ref.closeAll();
      }
    });
  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

  onPost() {
    if (this.buisnessPromotionData.hash_id === '') {
      this.buisnessPromotionData.hash_id = undefined;
    }
    this.assetList.map((d, i) => {
      if (d.thumbnail) {
        this._assetInfo.push({
          thumbImgUrl: d.thumbnail?.replace('200x200', '400x400'),
          imgUrl: d.url,
          assetType: 5,
          isDelete: undefined,
        });
      }
    });
    console.log(this._assetInfo);
    this.buisnessPromotionData.assetInfo = this._assetInfo;
    console.log('Data', this.buisnessPromotionData);
    if (this.buisnessPromotionData.targetCountry === '') {
      if (!this.editMode) {
        this.buisnessPromotionData.targetCountry = undefined;
        this.buisnessPromotionData.targetState = undefined;
        this.buisnessPromotionData.targetCity = undefined;
      } else {
        this.buisnessPromotionData.targetCountry = 'null';
        this.buisnessPromotionData.targetState = 'null';
        this.buisnessPromotionData.targetCity = 'null';
      }
    }
    if (this.buisnessPromotionData.targetState === '') {
      if (!this.editMode) {
        this.buisnessPromotionData.targetCountry = undefined;
        this.buisnessPromotionData.targetState = undefined;
        this.buisnessPromotionData.targetCity = undefined;
      } else {
        this.buisnessPromotionData.targetCountry = 'null';
        this.buisnessPromotionData.targetState = 'null';
        this.buisnessPromotionData.targetCity = 'null';
      }
    }
    if (this.buisnessPromotionData.targetCity === '') {
      if (!this.editMode) {
        this.buisnessPromotionData.targetCountry = undefined;
        this.buisnessPromotionData.targetState = undefined;
        this.buisnessPromotionData.targetCity = undefined;
      } else {
        this.buisnessPromotionData.targetCountry = 'null';
        this.buisnessPromotionData.targetState = 'null';
        this.buisnessPromotionData.targetCity = 'null';
      }
    }
    this.buisnessPromotionData.postType = 5;
    this.buisnessPromotionData['searchType'] = 5;
    this.buisnessPromotionData.imgUrl = this._assetInfo[0]['imgUrl'];
    this._apiService.updateAdminPostInfo({
      postInfo: this.buisnessPromotionData,
    });
    // if (!this.editMode) {
    //   this.buisnessPromotionData['hash_id'] = undefined;
    // }
    // this._apiService.updateBuisnessPromotion({
    //   promotionInfo: this.buisnessPromotionData,
    // });
  }

  onUploadImage(event: any) {
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;

    if (this.fileName.includes(' ')) {
      this._snackBar.open('White spaces are not allowed in file name', 'OK', {
        duration: 3000,
      });
      return;
    }
    let sizeinKb = +event.target.files[0].size / 1000;
    // if (sizeinKb > 1021) {
    //   this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
    //   return;
    // }
    let extension = this.fileName.substring(this.fileName.lastIndexOf('.') + 1);
    console.log(extension);
    // this.assetList.push({
    //   assetName: this.fileName,
    // });
    this.loader = true;
    let formData: FormData = new FormData();
    formData.append('recfile', event.target.files[0]);
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
      console.log('image');
      if (sizeinKb > 1021) {
        this.loader = false;
        this._snackBar.open(
          'Image size should not exceed more then 1 mb',
          'Ok'
        );
        return;
      }
      this._apiService.uploadAssets(formData, 1);
      return;
    }
    if (extension === 'mp4' || extension === 'avi') {
      console.log('Video');
      this._apiService.uploadAssets(formData, 3);
      return;
    }
    this.loader = false;
    this._snackBar.open('File format not supported', 'Ok');

    // this._apiService.uploadAssets(formData, 1);
  }

  locationAutoComplete(event: any) {
    console.log('location', event.place.address_components);
    // administrative_area_level_1 = state
    // locality = city
    // country = country
    event.place.address_components?.forEach((data: any) => {
      let type = data.types[0];
      console.log(type);
      if (type === 'administrative_area_level_1') {
        this.buisnessPromotionData.targetState = data?.long_name;
      } else if (type === 'locality') {
        this.buisnessPromotionData.targetCity = data.long_name;
      } else if (type === 'country') {
        this.buisnessPromotionData.targetCountry = data.long_name;
      }
    });
  }
}
